/**
 * Takes an object and turns all the values into a string. Used by components to
 * turn objects of utility classes into a single string that can be used as a
 * className. It does not return boolean values including null and undefined so
 * that we can use boolean logic to conditionally add classes.
 *
 * If given: { base: 'w-full h-full', coloring: 'bg-black text-white' disabled:
 * isDisabled && 'opacity-50' }
 *
 * Outputs: "w-full h-full bg-black text-white" when isDisabled false "w-full
 * h-full bg-black text-white opacity-50" when isDisabled true
 *
 * @param {object} obj A key/value map of
 * @returns String
 */
export const classify = (obj: object): string =>
  Object.values(obj)
    .filter(v => v != null && v !== false)
    .join(' ')
    .replace(/\s+/g, ' ')
